import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Switch } from '../../components/ui/switch';
import { Bot, Zap, TrendingUp, Target, Play } from 'lucide-react';

const ICONS = {
  options_day_trades: Zap,
  swing_trades: TrendingUp,
};

const CategoryRow = ({ cat, subscribed, recents, runningCat, tgLinked, onToggle, onRunNow }) => {
  const Icon = ICONS[cat.id] || Target;
  return (
    <div
      className={`border rounded-lg p-3 transition-all ${
        subscribed ? 'border-purple-500 bg-purple-50' : 'border-gray-200'
      }`}
      data-testid={`signal-cat-${cat.id}`}
    >
      <div className="flex items-start justify-between gap-2 mb-2">
        <div className="flex items-center gap-2">
          <div
            className={`p-2 rounded-lg ${
              subscribed ? 'bg-purple-600 text-white' : 'bg-gray-100 text-gray-600'
            }`}
          >
            <Icon size={16} />
          </div>
          <div>
            <p className="font-semibold text-sm">{cat.label}</p>
            <p className="text-xs text-gray-500">{cat.description}</p>
          </div>
        </div>
        <Switch
          checked={subscribed}
          onCheckedChange={() => onToggle(cat.id)}
          data-testid={`signal-toggle-${cat.id}`}
        />
      </div>

      {subscribed && (
        <>
          <div className="flex justify-between items-center mt-2">
            <span className="text-xs text-gray-500">Last 5 signals</span>
            <Button
              size="sm"
              variant="ghost"
              className="h-6 text-xs"
              disabled={runningCat === cat.id || !tgLinked}
              onClick={() => onRunNow(cat.id)}
              data-testid={`signal-run-${cat.id}`}
            >
              <Play size={10} className="mr-1" />
              {runningCat === cat.id ? 'Running…' : 'Run now'}
            </Button>
          </div>
          <div className="mt-1 space-y-1 max-h-28 overflow-y-auto">
            {recents.length === 0 && <p className="text-xs text-gray-400">No signals yet.</p>}
            {recents.map((s) => (
              <div key={s.id} className="text-xs flex justify-between">
                <span className="font-medium">{s.symbol}</span>
                <span className="text-gray-500">
                  ${s.price} · {s.conviction}
                </span>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

const SignalsCard = ({
  signalCats,
  subCats,
  recentByCat,
  runningCat,
  tgLinked,
  onToggle,
  onRunNow,
}) => (
  <Card className="mb-8" data-testid="ai-signals-card">
    <CardHeader>
      <CardTitle className="text-lg flex items-center gap-2">
        <Bot size={18} className="text-purple-600" /> AI Trade Signals
      </CardTitle>
      <p className="text-xs text-gray-500">
        Pick which strategies to receive via Telegram. Signals run hourly during market hours.
      </p>
    </CardHeader>
    <CardContent>
      {!tgLinked && (
        <div className="mb-3 text-xs font-medium text-amber-900 bg-amber-100 border border-amber-300 rounded p-2">
          Link Telegram above to receive signals.
        </div>
      )}
      <div className="grid md:grid-cols-3 gap-3">
        {signalCats.map((c) => (
          <CategoryRow
            key={c.id}
            cat={c}
            subscribed={subCats.includes(c.id)}
            recents={recentByCat[c.id] || []}
            runningCat={runningCat}
            tgLinked={tgLinked}
            onToggle={onToggle}
            onRunNow={onRunNow}
          />
        ))}
      </div>
    </CardContent>
  </Card>
);

export default SignalsCard;
